import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import { ICreateInvoice } from "@shared/lib/types/briefCampains";
import { FINANCE_INFLUENCER_QUERY_KEY } from "../contsants";

export function useCreateInvoice(campaignInfluencerId: string) {
  const {
    mutate: createInvoice,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation<ICreateInvoice>({
    mutationFn: async (invoice) => {
      return await CampaignService.createInvoice(invoice).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId)],
      });
      // TODO: Invalidate relevant queries here
    },
    options: {},
  });

  return {
    createInvoice,
    isCreating,
    isCreated,
  };
}
